
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiClassificheGrid extends Serenity.EntityGrid<UtentiProdottiClassificheRow, any> {
        protected getColumnsKey() { return UtentiProdottiClassificheColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiClassificheDialog; }
        protected getIdProperty() { return UtentiProdottiClassificheRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiClassificheRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiClassificheRow.localTextPrefix; }
        protected getService() { return UtentiProdottiClassificheService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this,
                autoSizeAllJustOnce: false,
                useExplicitWidths: true,
                ignoreHeaders: 800,
                maxWidth: 800,
                minWidth: 300
            });

            return this.slickGrid;
        }

        protected getSlickOptions(): Slick.GridOptions {
            let opt = super.getSlickOptions();
            //opt.rowHeight = 150;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return (this.IdUtenteProdotto > 0);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            return buttons;
        }

        protected addButtonClick() {
            super.addButtonClick();

            this.editItem(<Gamification.UtentiProdottiClassificheRow>{
                IdUtenteProdotto: this.IdUtenteProdotto,
                IdUtenteProdottoIdProdotto: this.IdProdotto
            });

            //var theDialog = new UtentiProdottiClassificheDialog();
        //    theDialog.IdProdotto = this.IdProdotto;
        //    theDialog.IdUtenteProdotto = this.IdUtenteProdotto;
        //    theDialog.onSuccess = () => {
        //        Q.notifyError("A");
        //        this.view.refresh(); Serenity.SubDialogHelper.triggerDataChange(this); return true;
        //    };
        //    theDialog.loadNewAndOpenDialog();
        }

        // ///////////////////////////////////////////////////////////////
        private _IdUtenteProdotto: number;
        private _IdProdotto: number;

        get IdUtenteProdotto() {
            return this._IdUtenteProdotto;
        }

        set IdUtenteProdotto(value: number) {
            if (this._IdUtenteProdotto != value) {
                this._IdUtenteProdotto = value;
                this.setEquality(UtentiProdottiClassificheRow.Fields.IdUtenteProdotto, value);
                this.refresh();
            }
        }

        get IdProdotto() {
            return this._IdProdotto;
        }

        set IdProdotto(value: number) {
            if (this._IdProdotto != value) {
                this._IdProdotto = value;
            }
        }
    }
}